<div class="container" [class.visible]="isVisible" #element>
  <div class="stats">
    <div class="stat">
      <div [countUp]="count" [duration]="duration">10+</div>
      <div>years in the IT industry</div>
    </div>
    <div class="stat">
      <div>25+</div>
      <div>satisfied clients</div>
    </div>
    <div class="stat">
      <div>50+</div>
      <div>completed projects</div>
    </div>
  </div>
</div>

